import React from 'react';

import {assert} from 'Asserts';
import {FilterKey, SingleValueFilter} from 'search/SearchConstants';
import pick from 'util/pick';

import DropdownFilterForm from './base/DropdownFilterForm';
import {BASE_FILTER_FORM_PROP_NAMES, BaseFilterFormProps, FilterStyle} from './base/FilterFormConstants';

export enum RegistrationStatusFilterValue {
  REGISTERED = 'REGISTERED',
  UNREGISTERED = 'UNREGISTERED',
}

export interface RegistrationStatusFilter extends SingleValueFilter {
  key: FilterKey.REGISTRATION_STATUS;
  value: RegistrationStatusFilterValue;
}

interface Props extends BaseFilterFormProps {
  filter: RegistrationStatusFilter;
  filterStyle: FilterStyle;
  onChangeFilter: (filter: RegistrationStatusFilter) => void;
  onRemove?: () => void;
}

const RegistrationStatusFilterForm: React.SFC<Props> = (props: Props): JSX.Element => {
  const skeletonProps = pick(props, ...BASE_FILTER_FORM_PROP_NAMES);
  assert(
    props.filterStyle === FilterStyle.SECONDARY,
    'Registration status filter is only configured to work as a secondary filter'
  );
  return (
    <DropdownFilterForm
      {...skeletonProps}
      filterStyle={props.filterStyle}
      isMulti={false}
      onChangeValue={(value: RegistrationStatusFilterValue) => {
        props.onChangeFilter({...props.filter, value});
      }}
      onRemove={props.onRemove}
      optionDatas={[
        {name: 'Registered', value: RegistrationStatusFilterValue.REGISTERED},
        {name: 'Unregistered', value: RegistrationStatusFilterValue.UNREGISTERED},
      ]}
      value={props.filter.value}
    />
  );
};

export default RegistrationStatusFilterForm;
